<template>
  <div class="page--crud_list">
    <Popup ref="modal_popup">
      <ApiViewDetailsModal :setting="currentSetting.view" :data="selected_item" :namespace="key" v-if="typeof currentSetting.view == 'object'"/>
      <ViewDetailsModal :setting="currentSetting.view" :data="selected_item" :namespace="key" v-else/>
    </Popup>
    <Popup ref="import_popup">
      <Import :setting="currentSetting.import" :namespace="key" @close="closePopupImport" :options="options" />
    </Popup>
    <!-- <div class="title">{{ key }}</div> -->
    <div class="content">
      <div class="action-btn">
        <div v-if="currentSetting.action && currentSetting.action.includes('create')">
          <el-button @click="go(`${key}/create`)" type="primary" size="mini" v-if="hasRightToCreate">{{ $t("button.create") }}</el-button>
        </div>
        <div class="space"></div>
        <div class="export-btn" v-if="currentSetting.export || currentSetting.import">
          <el-button @click="popupImport" v-if="currentSetting.import && hasRightToCreate" type="success" size="mini">
            <fa :icon="['fas','file-import']" style="margin-right:5px;"/>{{ $t("label.import") }}
          </el-button>
          <select v-model="default_max_row" v-if="currentSetting.export && currentSetting.export.includes('excel') && permissions.includes('cstDebug')">
            <option v-for="r in default_max_row_list" :key="r" :value="r">{{r}}</option>
          </select>
          <el-button @click="clickExportExcel" type="warning" size="mini" v-if="currentSetting.export && currentSetting.export.includes('excel')">
            <fa :icon="['fas','file-export']" style="margin-right:5px;"/>{{ $t("label.export_as_") }}Excel
          </el-button>
          <!-- <a :href="exportExcel(key, currentSetting, filter)" :download="`${key}_export_${new Date().getTime()}.csv`">Excel</a> -->
        </div>
      </div>
      <el-tabs type="card" @tab-click="tabChanged">
        <el-tab-pane :label="$te(`menu.item.${currentSetting.key}`) ? $t(`menu.item.${currentSetting.key}`) : currentSetting.key"></el-tab-pane>
        <el-tab-pane :label="$t('label.trash')" v-if="currentSetting.trash"></el-tab-pane>
      </el-tabs>
      <div class="tab-content">
        <div class="filter-table" @mouseenter="onFilterMouseLeave">
          <el-tag
            v-for="(field) in currentSetting.fields"
            :key="field.key" 
            v-show="Array.isArray(filter[field.key]) || ['string','number'].includes(typeof filter[field.key])"
            @close="closeTag(field.key)"
            size="mini"
            closable
            :class="[
              { 'current': effect.mouse_over == field.key },
              { 'other': effect.mouse_over != null && effect.mouse_over != field.key }
            ]"
          >
            <div class="label">
              {{ tran(key, field.key) }}
            </div>
            <div class="value">
              {{ filter.hasOwnProperty(field.key) ? getFilterValue(field) : "" }}
            </div>
          </el-tag>
          <div class="filer-button__wrap" v-show="typeof this.currentSetting.filters == 'undefined' ? false : true ">
            <el-button @click="resetAllFilter" type="info" size="mini"><fa :icon="['fas', 'redo-alt']"/>{{ $t("button.reset") }}</el-button>
            <el-button @click="executeAllFilter" type="primary" size="mini"><fa :icon="['fas', 'filter']"/>{{ $t("button.filter") }}</el-button>
          </div>

        </div>
        <vxe-table
          ref="table"
          class="main-table"
          size="mini"
          border
          show-header-overflow
          show-overflow
          highlight-hover-row
          :empty-text="$t('label.no_data_found')"
          @filter-change="filterChanged"
          @sort-change="sortChanged"
          :remote-sort="true"
          @cell-click="clickedCell"
          :loading="loading"
          :key="new Date().getTime()"
          :resizable="true"
          :data="tableData">

          <vxe-table-column
            v-for="(field) in currentSetting.fields" :key="field.key"
            :field="field.key"
            :title="field.key"
            :filters="field.type != 'action-btn' && currentSetting.filters && currentSetting.filters.hasOwnProperty(field.key) ? [currentSetting.filters[field.key].hasOwnProperty('type') && ['select','multiselect'].includes(currentSetting.filters[field.key].type) ? false : ''] : null"
            :filter-render="filterRender(field.key)"
            :filter-change="filterChanged"
            :class-name="shouldHighlight"
            :sortable="currentSetting.sort_fields ? currentSetting.sort_fields.includes(field.key) : false"
            :width="field.width?field.width:getDefaultWidth(field.type)"
          >
            <template v-slot:header="{ columnIndex }">
              <div class="detect-block"
                @mouseover.stop="onFilterMouseOver(currentSetting.fields[columnIndex].key)"
              ></div>
              <div class="header-wrap">
                <div class="name">
                  {{ tran(key, currentSetting.fields[columnIndex].key) }}
                </div>
                <!-- <div class="filter-value">{{ filter.hasOwnProperty(field.key) ? getFilterValue(field) : "" }}</div> -->
              </div>
            </template>
            <template v-slot="{ row }">
              <div v-if="field.type == 'boolean'">
                <el-checkbox :checked="row[field.key] == 1"/>
                <div class="block-layer"></div>
              </div>

              <div v-else-if="field.type == 'datetime'">
                {{ row[field.key] ? $moment(row[field.key]).format("YYYY-MM-DD HH:mm:ss") : field.fill ? $moment().format("YYYY-MM-DD HH:mm:ss") : "" }}
              </div>

              <div v-else-if="field.type == 'date'">
                {{ row[field.key] ? $moment(row[field.key]).format("YYYY-MM-DD") : field.fill ? $moment().format("YYYY-MM-DD") : "" }}
              </div>

              <div v-else-if="field.type == 's_to_hms'">
                {{ row[field.key] ? getTime(row[field.key]) : "00:00:00" }}
              </div>
              <Component :is="field.component" v-else-if="field.type == 'componentColumn'" :k="key" :action="'List'" :field="field" :data="row" @needUpdate="fetchData" :ref="`componentColumn-${field.key}`" :options="options" :row="row"/>

              <div v-else-if="field.type == 'href'">
                <a v-if="displayHrefUrl(row, field)" :href="hrefUrl(row, field)" >{{row[field.key]}}</a>
                <div v-else>{{row[field.key]}}</div>
              </div>

              <div v-else-if="field.type == 'hrefweb'">
                <a target="_blank" v-if="row[field.key]" :href="row[field.key]">{{row[field.key]}}</a>
              </div>

              <div v-else-if="field.type == 'components'" >
                <component v-if="disabledByColumnValue(row,field)" class="component" :is="field.component" :data="row" :field="field"  @needUpdate="fetchData"></component>
              </div>

              <div v-else-if="field.type == 'select' && field.options">
                {{options[field.options.key].filter(
                  option => {
                      if (option.value == row[field.key]){
                        return true;
                      }
                    return false;
                  }
              )[0]?.label}}
              </div>

              <div class="action" v-else-if="field.type == 'action-btn' && currentSetting.action.length > 0">
                <div v-if="trashMode==0">
                    <el-button
                      type="info"
                      size="mini"
                      @click="$router.push({ name: 'View', params: { id: currentSetting.id ? row[currentSetting.id] : row.id } })"
                      v-if="currentSetting.action.includes('view')"
                    >
                      <fa :icon="['fas', 'list-alt']"/>
                    </el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="$router.push({ name: 'Edit', params: { id: currentSetting.id ? row[currentSetting.id] : row.id } })"
                    v-if="hasRightToEdit && actionCheck('edit',row)"
                  >
                    <fa :icon="['fas', 'pen']"/>
                  </el-button>
                  <el-button
                    type="warning"
                    size="mini"
                    @click="$router.push({ name: 'EditView', params: { id: currentSetting.id ? row[currentSetting.id] : row.id } })"
                    v-if="hasRightToEditView && actionCheck('editview',row)"
                  >
                    <fa :icon="['fas', 'edit']"/>
                  </el-button>
                  <el-button
                    type="info"
                    size="mini"
                    @click="popupDetails(currentSetting.id ? row[currentSetting.id] : row.id)"
                    v-if="currentSetting.action.includes('pop-view')"
                  >
                    <fa :icon="['fas', 'list-alt']"/>
                  </el-button>
                  <el-button
                    type="info"
                    size="mini"
                    @click="downloadPdf(currentSetting.id ? row[currentSetting.id] : row.id)"
                    v-if="currentSetting.action.includes('download-pdf')"
                  >
                    <fa :icon="['fas', 'download']"/>
                  </el-button>
                  <el-button
                    type="info"
                    size="mini"
                    @click="clickedDelete(currentSetting.id ? row[currentSetting.id] : row.id)"
                    v-if="hasRightToDelete && disabledByColumn(row)"
                  >
                    <fa :icon="['fas', 'trash-alt']"/>
                  </el-button>
                </div>
                <div v-else>
                  <el-button type="warning" size="mini" @click="clickedChangeActive(row.id, 1)">
                    <fa :icon="['fas', 'undo-alt']"/>
                  </el-button>
                  <el-button type="danger" size="mini" @click="clickedDelete(row.id)">
                    <fa :icon="['fas', 'trash-alt']"/>
                  </el-button>
                </div>
              </div>

              <div v-else-if="field.type == 'float'">
                {{ getFloating( field, field.hasOwnProperty("field") ? getValueByField(row, field) : row[field.key] ) }}
              </div>

              <div v-else-if="field.type == 'number'">
                {{ field.hasOwnProperty("field") ? getValueByField(row, field) : row[field.key] ? row[field.key] : 0 }}
              </div>

              <div v-else>{{ field.hasOwnProperty("field") ? getValueByField(row, field) : row[field.key] }}</div>
              
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="footer">
        <div class="result">
          {{ $tc("label.total_record_desc", pagination.max > 0 ? 2 : 1, { row: pagination.item, page: pagination.current, max_page: pagination.max }) }}
          <span>
            <label>, {{$t('label.show_per_page')}}</label>
            <select v-model="pagination.perPage"
            @change="fetchData"
            >
              <option v-for="showPerPageOption in getShowPerPage" :key="showPerPageOption.id">{{ showPerPageOption }}</option>
            </select>
          </span>
        </div>
        <div class="pagination">
          <el-pagination
            background
            @current-change="changePage"
            :current-page.sync="pagination.current"
            :page-size="1"
            layout="jumper, prev, pager, next"
            :total="pagination.max">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import crud from "@/settings/crud";
import ViewDetailsModal from "@/views/crud/modules/ViewDetailsModal";
import ApiViewDetailsModal from "@/views/crud/modules/ApiViewDetailsModal";
import Import from "@/views/crud/Import";
import { mapState } from 'vuex';

export default {
  components: {
    ViewDetailsModal,
    ApiViewDetailsModal,
    Import
  },
  async beforeMount() {
    console.warn("beforeMount");
    console.log("list",this.$route.params.search);

    this.$store.commit("control/setLoad", true);
    this.key = this.$route.params.key;
    Object.assign(this.currentSetting, this.$setting.crud[this.key]);
    this.pagination.perPage = this.getShowPerPage[0];
    this.currentSetting.fields = [...this.currentSetting.fields.filter(f=>{
      if(f.type == "action-btn") return typeof this.currentSetting.action != "undefined";
      if(f?.hidden?.includes("list")) return false;
      // privilege check
      if(f?.privilege) {
        console.log("privilege", f.privilege);
        let auth = true;
        f.privilege.map(p=>{
          if(!this.permissions.includes(p)) {
            console.log("p: ", p);
            auth = false;
          }
        });
        console.log("auth: ",auth);
        return auth;
      }
      //
      if(typeof f.hidden == "undefined") return true;
      return true;
    })];
    if(this.$route.query.page) {
      this.pagination.current = this.$route.query.page;
    }
    // default filterfilters
    if(this.currentSetting.filters) {
      Object.keys(this.currentSetting.filters).map(key=>{
        if(this.currentSetting.filters[key].hasOwnProperty("default")) {
          this.filter[key] = this.currentSetting.filters[key].default;
        }
      });
      if(this.$route.params.search){
        const search_obj = JSON.parse(this.$route.params.search);
        Object.keys(search_obj).map(key=>{
          if(this.currentSetting.filters[key] != undefined){
            if(this.currentSetting.filters[key].type == "multiselect"){
              this.filter[key] = [];
              this.filter[key][0] = search_obj[key];
            }
            else {
              this.filter[key] = search_obj[key];
            }
          }
        });
        console.log(this.filter)
      }
    }
    if(this.$route.params.search == undefined &&localStorage.listPage == this.key){
      var params = JSON.parse(localStorage.listPageParams);
      this.filter = {};
      for(var i in params){
        if(i == 'size') {
          this.pagination.perPage = params[i];
        }
        else if(i == 'page') {
          this.pagination.current = parseInt(params[i])+1;
        }
        else if(i == 'sort_by') {
          this.sort.field = params[i];
        }
        else if(i == 'order') {
          this.sort.order = params[i];
        }
        else if(i == 'trash') {
          this.trashMode = params[i];
        }
        else {
          this.filter[i] = params[i];
        }
      }
      
    }
    await this.fetchData();
    this.$store.commit("control/setLoad", false);
  },
  async mounted() {
    console.warn("mounted");
  },
  methods: {
  async fetchData() {
      this.loading = true;
      
      var params =  {
        size: this.pagination.perPage,
        page: this.pagination.current > 0 ? this.pagination.current - 1 : 0,
        sort_by: this.sort.field ? this.sort.field : this.currentSetting?.sort?.field,
        order: this.sort.order ? this.sort.order : this.currentSetting?.sort?.order,
        ...this.filter,
        trash: this.trashMode == 1 ? 1 : 0
      };
      localStorage.listPage = this.key;
      localStorage.listPageParams = JSON.stringify(params);
      console.log(localStorage);
      await this.$axios.get(`/${this.key}`, {
        params: params
      }).then(res=>{
        let data = res.data.response.dataset;
        this.tableData = data.content.filter(data=>{
          let id = this.currentSetting.id ? this.currentSetting.id : "id";
          if(!data.hasOwnProperty(id)) return true;
          return data[id] > 0;
        });
        this.pagination.max = data.totalPages;
        if(this.pagination.current > this.pagination.max && this.pagination.max > 0) {
          this.pagination.current = this.pagination.max;
          this.fetchData();
        }
        this.pagination.item = data.totalElements;
        this.$refs.table.updateData();
        return true;
      }).catch(err=>{ return false; });
      if(this.currentSetting.options) {
        await this.$axios.get(`options?opts=${Object.keys(this.currentSetting.options).map(key=>this.currentSetting.options[key].key).join("&opts=")}`, {
          params: {
            // opts: 
          }
        }).then(res=>{
          let options = res.data.response.options;
  
          Object.keys(this.currentSetting.options).filter(opt=>options.hasOwnProperty(this.currentSetting.options[opt].key)).map(opt=>{
            console.log(opt);
            let key = this.currentSetting.options[opt].key;
            this.options[key] = options[key].map(value=>{
              return {
                label: typeof value == "object" ? value[this.currentSetting.options[opt].label] : value,
                value: typeof value == "object" ? value[this.currentSetting.options[opt].value] : value,
              }
            });
          });
          return true;
        }).catch(err=>{ return false; });
      }
      console.log(this.options)
      // datatype: id
      let fieldTypeId = this.currentSetting.fields.filter(f=>f?.datatype=="id").map(f=>f.key);
      this.tableData.map((data,i)=>{
        Object.keys(data).filter(d=>fieldTypeId.includes(d)).map(key=>{
          console.log("key: ",key);
          let opt_key = this.currentSetting.options[key].key;
          let obj = this.options[opt_key].find(obj=>obj.value==this.tableData[i][key]);
          this.tableData[i][key] = obj ? obj.label : '';
        });
      });


      this.loading = false;
      return true;
    },
    getParams() {
      return {
        ...this.filter,
        sort_by: this.sort.field ? this.sort.field : this.currentSetting?.sort?.field,
        order: this.sort.order ? this.sort.order : this.currentSetting?.sort?.order,
        size: this.currentSetting?.excel?.max_row || this.default_max_row,
      }
    },
    filterChanged({datas, column}) {
      console.warn("column: ",column);
      console.warn("filter changed: ",datas);
      let field_setting = this.currentSetting.fields.hasOwnProperty(column.property) ? this.currentSetting.fields[column.property] : {};
      let filter_setting = this.currentSetting.filters.hasOwnProperty(column.property) ? this.currentSetting.filters[column.property] : {};

      if(filter_setting.type == "daterange") {
        this.filter[column.property] = datas.length > 0 ? datas[0].map((data,index)=>{
          if(index == 0) {
            return this.$moment(data).unix();
          }else if(index == 1) {
            // make sure it is 23:59:59
            return this.$moment(data).add(1, "days").unix();
          }
        }) : undefined;
      } else if (filter_setting.type == "boolean"){
        this.filter[column.property] = datas.length > 0 ? datas[0] : 0;
      } else {
        this.filter[column.property] = datas.length > 0 ? datas[0] : undefined;
      }
      // this.fetchData();
      this.$forceUpdate();
    },
    changePage(page) {
      this.selected_row = -1;
      this.pagination.current = page;
      this.fetchData();
    },
    async clickedChangeActive(id, active) {
      let type = active ? "Restore" : "Delete";
      let confirm = await this.$confirm(`Are you sure to ${type}`, type, {
        confirmButtonText: type,
        cancelButtonText: 'Cancel',
        type: 'warning'
      });
      // if cancel, then break
      if(!confirm) return;
      let loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      await this.$axios.put(`/${this.key}/${id}/active`, {
        active
      });
      loading.close();
      this.fetchData();
    },
    async clickedDelete(id){
      var _this = this;
      var data = undefined;
      var msg = "";
      try {
        data = (await this.$axios.get(`/${this.key}/checkDelete/${id}`)).data;
      } catch (error) {}

      if(data?.msgCode){
        msg = _this.$t(`message.${data?.msgCode}`)
      }
      let confirm = await _this.$confirm( msg, _this.$tc("message.confirm_to_delete",null,{ id: id }), {
        confirmButtonText: _this.$t("message.confirm"),
        cancelButtonText: _this.$t("message.cancel"),
        type: 'warning'
      }).catch(()=>{return false;});
      if(confirm) {
        _this.deleted(id);
      }
    },
    async deleted(id) {
      // let confirm = await this.$confirm(this.$tc("message.confirm_to_delete",null,{ id: id }) , '', {
      //   confirmButtonText: this.$t("message.confirm"),
      //   cancelButtonText: this.$t("message.cancel"),
      //   type: 'warning'
      // }).catch(()=>{return false;});;
      // if(!confirm) return;
      let loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // if cancel, then break
      if(!confirm) return;

      await this.$axios.delete(`/${this.key}/${id}`).then(res=>{
        console.log(res)
        if(res.data == 'Deleted'){
          this.fetchData();
        }
        else {
          this.$message({
            message: "Delete error",
            type: 'error'
          });
        }

        return true;
      }).catch(err=>{
        console.error(err);
        return false;
      });
      loading.close();
    },
    tabChanged(tab) {
      this.trashMode = tab.index;
      this.fetchData();
    },
    getValueByField(row, field) {
      // if(Array.isArray();
      let split = field.field.split(".");
      let value = row;
      // if(split.length > 0) split.unshift(field.key);
      split.map(f=>{
        if(typeof value != "object") return;
        if(value == null) return;
        if(Array.isArray(value[f]) && split.length >= 2) {
          let list = value[f];
          value = list.map(arr=>arr[split[1]]).join(", ");

        }else {
          value = value.hasOwnProperty(f) ? value[f] : "";
        }
      });
      return value;
    },
    getFloating(field, value) {
      if(value == null) return;
      if(field.decimal_point) {
        return (value/1000).toFixed(field.decimal_point);
      }else {
        return value/1000;
      }
    },
    getDefaultWidth(type){
      if (type == "datetime"){
        return 140;
      }else if (type) {
          return 80;
      };
    },
    showDetails(id) {
      console.log(id);
      this.selected = id;
      // this.$refs.modal_popup.show();
      console.log("key: ",this.key);
      // this.$router.push({ name: "View", params: { key: this.key, id} });
    },
    popupDetails(id) {
      this.selected = id;
      this.$refs.modal_popup.show();
      console.log(id);
    },
    popupImport() {
      this.$refs.import_popup.show();
    },
    async closePopupImport() {
      await this.fetchData();
      this.$refs.import_popup.close();
    },
    async downloadPdf(id) {
      await this.fetchData();
      this.exportPdf(this.key, this.currentSetting, id);

    },
    clickedCell({ rowIndex }) {
      this.selected_row = rowIndex;
    },
    shouldHighlight({ rowIndex }) {
      if(rowIndex == this.selected_row) {
        return "row-clicked";
      }
    },
    sortChanged({column, property, order, $event}) {
      console.log("column: ",column);
      console.log("property: ",property);
      console.log("order: ",order);
      console.log("$event: ",$event);
      this.sort.field = property;
      this.sort.order = order;
      this.fetchData();
    },
    fillZero(num) {
      num = Math.abs(num);
      return num < 10 ? `0${num}` : num;
    },
    getTime(sec) {
      // let h = Math.abs(Math.floor(sec/(60*60)));
      let h = Math.floor(sec/(60*60));
      let m = Math.floor(sec/(60)) - h*60;
      let s = sec%60;

      if(sec > 0) {
        return `${this.fillZero(h)}:${this.fillZero(m)}:${this.fillZero(s)}`;
      }else {
        return `-${this.fillZero(h)}:${this.fillZero(m)}:${this.fillZero(s)}`;
      }
    },
    getFilterValue(field) {
      if(this.currentSetting.options && this.currentSetting.options.hasOwnProperty(field.key)) {
        if(Array.isArray(this.filter[field.key])) {
          let arr = [];
          return this.filter[field.key].map(val=>{
            let opt = this.currentSetting.options[field.key];
            let value = val;
            try {
              value = this.options[opt.key].find(option=>option.value==val);
            } catch (error) {

            }
            console.log(value);
            return value ? value.label : "";
          }).join(", ");
        }else {
          let opt = this.currentSetting.options[field.key];
          let value;
          try {
            value = this.options[opt.key].find(option=>option.value==this.filter[field.key]);
          } catch (error) {

          }
          
          return value ? value.label : "";
        }
      }else {
        if(this.currentSetting?.filters.hasOwnProperty(field.key) && this.currentSetting.filters[field.key].hasOwnProperty("type") && this.filter.hasOwnProperty(field.key)) {
          let type = this.currentSetting.filters[field.key].type;
          if(type == "daterange" && this.filter[field.key]) {
            return `${this.$moment.unix(this.filter[field.key][0]).format("YYYY-MM-DD")} ~ ${this.$moment.unix(this.filter[field.key][1]).add(-1, "days").format("YYYY-MM-DD")}`;
          }else if(type == "boolean") {
            return this.filter[field.key] == 1 ? this.$t("filter.boolean.true") : this.$t("filter.boolean.false");
          }
        }else {
          return this.filter.hasOwnProperty(field.key) ? this.filter[field.key] : "";
        }
      }
    },
    closeTag(key) {
      delete this.filter[key];
      this.fetchData();
      this.$forceUpdate();
    },
    onFilterMouseOver(key) {
      if(this.effect.mouse_over == key) return;
      if(typeof this.filter[key] == "undefined") return;
      this.effect.mouse_over = key;
    },
    onFilterMouseLeave() {
      if(this.effect.mouse_over == null) return;
      this.effect.mouse_over = null;
    },
    filterRender(key) {
      
      if(typeof this.currentSetting.filters == 'undefined') return;

      let currentFilterObj = {};
      if (!this.currentSetting.filters[key]?.type){
        currentFilterObj = { name:'FilterInput' };
      }

      let filterType = this.currentSetting.filters[key]?.type;

      if ( filterType == 'multiselect' || filterType == 'select' ) {
        currentFilterObj = {
            name: this.filter_type_mapping[filterType],
            options: this.options[this.currentSetting.options[key].key],
          };
      }

      if ( filterType == 'daterange' ) {
        currentFilterObj = {
            name: this.filter_type_mapping[filterType],
            options: [],
            props: {type: 'daterange', format: 'yyyy-MM-dd'},
            filterable: this.currentSetting.filters.filterable
          };
      }

      if ( filterType == 'boolean' ) {
        currentFilterObj = {
            name: this.filter_type_mapping[filterType],
          };
      }

      if(this.filter[key]){
        currentFilterObj.selectedOptions = this.filter[key];
      }

      return currentFilterObj;

    },
    resetAllFilter() {
      console.log("this.filter:::::",this.filter)
      this.filter = {};
      if(this.currentSetting.filters) {
        Object.keys(this.currentSetting.filters).map(key=>{
          if(this.currentSetting.filters[key].hasOwnProperty("default")) {
            this.filter[key] = this.currentSetting.filters[key].default;
          }
        });
      }
      this.fetchData();
    },
    executeAllFilter() {
      console.log("this.filter:::::",this.filter)
      this.fetchData();
    },
    async clickExportExcel() {
      await this.fetchData();
      this.exportExcel(this.key, this.currentSetting, this.getParams());
    },
    hrefUrl(url){

    },
    displayHrefUrl(row, field){
      const val = row[field.key];
      if(!val) return false;
      if(field.display_val == undefined || field.display_val.length == 0) return true;
      if(field.display_val.indexOf(val) == -1) return false;
      return true;
    },
    hrefUrl(row, field){
      var url = field.url;
      var json = "";
      if(field.url_key){
        var obj = {};
        for(var i in field.url_key){
          var o = field.url_key[i];
          const myArray = o.row_key.split(".");
          console.log(myArray);
          var myData = row;
          for(var j in myArray){
            myData = myData[myArray[j]];
            console.log(myArray[j],myData);
          }
          if(myData){
            var s = '';
            if(o.str){
              s = o.str;
            }
            obj[o.search_key] = s+myData;

          }
          else {
            obj[o.search_key] = "";
          }
        }
        json = encodeURIComponent(JSON.stringify(obj));
      }
      url += json;
      if(this.$conf.NAMESPACE == ''){
          return "/"+url+"/search";
      }
      return "/" + this.$conf.NAMESPACE + "/"+url+"/search";
    },
    disabledByColumnValue(data,fields){
      var isShow = true;
      if(fields?.display_param){
        fields?.display_param.map(field => {
          console.log(data[field.key]);
          console.log(field.type);
          if(field.type == "eq"){
            if(data[field.key] != field.val){
              isShow = false;
            }
          }
          else if(field.type == "isNotEmpty"){
            if(data[field.key] == undefined || data[field.key] == "" || data[field.key] == null){
              isShow = false;
            }
          }
        });
      }
      return isShow;
    },
    disabledByColumn(data){
      
      var meet_the_conditions = true;
      if(this.currentSetting?.disabled_by_column?.list){
        meet_the_conditions = this.meetTheConditions(this.currentSetting?.disabled_by_column?.list,data);
        // this.currentSetting?.disabled_by_column?.list.map(field => {
        //   console.log(data[field.key]);
        //   console.log(field.type);
        //   if(field.type == "eq"){
        //     if(data[field.key] != field.val){
        //       meet_the_conditions = false;
        //     }
        //   }
        //   else if(field.type == "isNotEmpty"){
        //     if(data[field.key] == undefined || data[field.key] == "" || data[field.key] == null){
        //       meet_the_conditions = false;
        //     }
        //   }
        // });
      }
      return meet_the_conditions;
    },
    actionCheck(action,row){
      var meet_the_conditions = true;
      if(this.currentSetting.action_setup && this.currentSetting.action_setup[action] != undefined){
        meet_the_conditions = this.meetTheConditions(this.currentSetting.action_setup[action],row);
      }
      return meet_the_conditions;
    },
    meetTheConditions(list,data){
      var meet_the_conditions = true;
      list.map(field => {
        console.log(data[field.key]);
        console.log(field.type);
        if(field.type == "eq"){
          if(data[field.key] != field.val){
            meet_the_conditions = false;
          }
        }
        else if(field.type == "isNotEmpty"){
          if(data[field.key] == undefined || data[field.key] == "" || data[field.key] == null){
            meet_the_conditions = false;
          }
        }
      });
      return meet_the_conditions;
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.user.user_info.permissions
    }),
    generated_pages() {
      let pages = [];
      let per = 5;
      let current = parseInt(this.pagination.current);
      let group = Math.ceil(current/per);

      for(let i=1; i<=this.pagination.max; i++) {
        if(Math.ceil(i/per) == group){
          if(i%5 == 0) {
            pages.push(i);
            pages.push(i+1);
          }else if(i%5 == 1) {
            if(i-1 > 0) {
              pages.push(i-1);
            }
            pages.push(i);
          }else {
            pages.push(i);
          }
        }
      }
      return pages;
    },
    selected_item() {
      return this.tableData.find(item=>item[this.currentSetting.id ? this.currentSetting.id : "id"]==this.selected);
    },
    hasRightToCreate() {
      return this.permissions.includes(`CREATE_${this.currentSetting.key}`.toUpperCase());
    },
    hasRightToEdit() {
      return this.currentSetting.action && this.currentSetting.action.includes('edit') && this.permissions.includes(`EDIT_${this.currentSetting.key}`.toUpperCase());
    },
    hasRightToEditView() {
      return this.currentSetting.action && this.currentSetting.action.includes('editview') && this.permissions.includes(`EDIT_${this.currentSetting.key}`.toUpperCase());
    },
    hasRightToDelete() {
      if(this.permissions.includes(`READ_DELETE`.toUpperCase())){
        return this.currentSetting.action && this.currentSetting.action.includes('delete') && this.permissions.includes(`EDIT_${this.currentSetting.key}`.toUpperCase());
      }
      return false;
    },
    getShowPerPage() {
      const perPageSetting = this.$setting.crud[this.key].page_setting;
      if (Array.isArray(perPageSetting)){
        return perPageSetting;
      }
      if (typeof perPageSetting == "object") {
        const min = perPageSetting.min;
        const max = perPageSetting.max;
        const step = perPageSetting.step;

        let tranformedPerPageSetting = [];
        let initOption = min;
        for(let i = 0; i <= (max-min)/step; i++) {
          tranformedPerPageSetting.push(initOption);
          initOption+= step;
        }
        return tranformedPerPageSetting;
      } 
      return [20,50,100,200];
    },
  },
  data() {
    return {
      default_max_row:40000,
      default_max_row_list:[
        1000,
        10000,
        20000,
        30000,
        40000,
        50000
      ],
      key: "",
      currentSetting: {},
      tableData: [],
      filter: {},
      loading: false,
      trashMode: 0,
      pagination: {
        perPage: 0,
        total: 0,
        current: 1,
        item: 0,
        max: 0
      },
      sort: {
        field: "",
        order: ""
      },
      filter_type_mapping: {
        text: "ElInput",
        select: "FilterSelect",
        boolean: "FilterSwitch",
        daterange: "FilterDaterange",
        multiselect: "FilterMultiSelect"
      },
      options: {},
      tag: {},
      selected: 0,
      selected_row: -1,
      effect: {
        mouse_over: null
      },
      object: {},
    }
  },
  beforeRouteEnter(to, from, next) {
    console.warn("beforeRouteEnter");
    if(!crud.hasOwnProperty(to.params.key)) {
      next("/error/404")
    }
    next();
  }
}
</script>

<style lang="scss">
.page--crud_list{
  .vxe-table--body-wrapper{
    height: calc(100vh - 300px);
  }
  .content{
    .main-table{
      .detect-block{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
      }
      zoom: .9;
      th,td{
        // zoom: .7;
      }
      .vxe-cell{
        padding-left: 5px;
        padding-right: 5px;
      }
    }
    .el-tabs{
      .el-tabs__header{
        margin-bottom: 0px;
      }
      .el-tabs__item{
        height: 30px;
        line-height: 30px;
      }
    }
    .tab-content{
      padding: 20px 5px;
      border: 1px solid #E4E7ED;
      border-top: 0px;
      // overflow-x: auto;
      .filter-table{
        margin-bottom: 10px;
        .el-tag{
          // display: flex;
          margin-right: 5px;
          .label,
          .value{
            display: inline-block;
          }
          .label{
            margin-right: 5px;
            // font-size: xx-small;
          }
          .value{
            font-weight: bold;
            font-size: small;
          }

          &.other{
            opacity: .4;
          }
          &.current{
            opacity: 1;
          }
        }
      }
    }
    .vxe-table--header{
      .vxe-cell{
        font-size: 12px;
      }
    }
    .vxe-table--body{
      .row-clicked{
        background: #ffe48d;
      }
      .vxe-cell{
        font-size: 12px;
      }
      .action{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .el-button{
          padding: 7px 7px;
        }
        & div > *:not(:first-child){
          margin-left: 5px;
        }
      }
    }
    .action-btn{
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      & > *:not(:first-child){
        margin-left: 10px;
      }
    }
    .el-checkbox{
      position: relative;
    }
    .block-layer{
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .header-wrap{
      line-height: 1.2;
      .filter-value{
        font-size: .5rem;
        color: blue;
      }
      .search{
        display: flex;
        input{
          width: 100%;
        }
      }
    }
    .footer{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .result{
        font-size: small;
      }
      .pagination{
        display: flex;
        margin-top: 10px;
        justify-content: flex-end;
        .page{
          font-size: x-small;
          cursor: pointer;
          user-select: none;
          width: 25px;
          height: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #c5e1ff;
          border-color: #c5e1ff;
          color: white;
          &:not(:last-child) {
            margin-right: 10px;
          }
          &.current{
            background-color: #409EFF;
            border-color: #409EFF;
          }
        }
      }
    }
  }
}
.filer-button__wrap {
  display: block;
  text-align: right;
  margin-top: 5px;
}
</style>